module.exports = __webpack_public_path__ + "static/media/ico-projects.013bb90d.svg";